import React from 'react';
import {Card} from "/src/_v2/ui/patterns/Card";

import {Section} from "/src/_v2/ui/layout/Section";
import {Container} from "/src/_v2/ui/layout/Container";

import {ParagraphTags} from "/src/_v2/ui/patterns/ParagraphTags";
import {Text} from "/src/_v2/ui/primitives/Text";
import {Button} from "/src/components/global/Button";

export const LeadershipSection = ({data, suptitleColor = "purple"}) => {

  return data && (
    <Section className={`tw:overflow-visible`}>
      <Container>
        <div className="tw:lg:grid tw:lg:grid-cols-12 tw:lg:gap-24">
          <div className="tw:lg:col-span-4 tw:xl:col-start-2 tw:max-lg:hidden tw:relative">
            <div className="tw:pt-64 tw:sticky tw:top-28">
              <img src={`/assets/_rd/pages/merged-mining/bitcoin-orange.svg`} alt="Bitcoin" width="270" height="422" className={`tw:mx-auto tw:block`} />
            </div>
          </div>
          <div className="tw:lg:col-span-7 tw:lg:col-start-6 tw:xl:col-span-5 tw:xl:col-start-7 tw:space-y-40 tw:md:space-y-64">
            <div className="tw:space-y-12 tw:md:space-y-24 tw:xl:space-y-40">
              <ParagraphTags prefix={data.number} text={data.suptitle} color={suptitleColor}/>
              {data.title && (
                <h2 className="tw:h3">{data.title}</h2>
              )}
            </div>
            <div className="tw:space-y-32 tw:md:space-y-40">
              {data?.items?.length > 0 && (
                <div className="tw:grid tw:gap-20 tw:xl:gap-24">
                  {data.items.map((item, index) => (
                    <Card
                      color={item.color}
                      title={item.title}
                      text={item.text}
                      key={index}
                    />
                  ))}
                </div>
              )}
              <div className="tw:flex tw:gap-12 tw:md:gap-16 tw:justify-between tw:items-start">
                <Text text={data.text} size="md"/>
                <Button
                  title={data.button.title}
                  url={data.button.url}
                  classes="btn-lg tw:whitespace-nowrap"
                  external={data.button.target === '_blank'}
                />
              </div>
            </div>

          </div>
        </div>

      </Container>
    </Section>
  );
};
